import { FC } from 'react';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 关闭按钮 */
const CloseButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

CloseButton.defaultProps = {
  icon: ICON_COLLECTION.CLOSE,
  text: '关闭',
};

export default CloseButton;
